import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import GraphBuilderPanel from '../analytics/GraphBuilderPanel';

const StoreDashboardGraphBuilderPage: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const editing = Boolean(id);

  return (
    <div className="store-dash">
      <div className="store-dash-toolbar">
        <div>
          <div className="store-dash-kicker">Fluora</div>
          <h1>{editing ? 'Edit graph' : 'Create graph'}</h1>
        </div>
        <Link to="/?tab=custom" className="btn btn-outline-secondary btn-sm">
          Cancel
        </Link>
      </div>

      <GraphBuilderPanel
        graphId={id}
        onSaved={() => navigate('/?tab=custom')}
        saveLabel={editing ? 'Save changes' : 'Save graph'}
      />
    </div>
  );
};

export default StoreDashboardGraphBuilderPage;
